import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function LinkIcon({ className, width = 17, height = 17 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-400', className)}
            width={width}
            height={height}
            viewBox='0 0 17 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.85438 10.4479H7.08354C6.79313 10.4479 6.55229 10.2071 6.55229 9.91667C6.55229 9.62625 6.79313 9.38542 7.08354 9.38542H8.85438C10.7102 9.38542 12.219 7.87667 12.219 6.02083C12.219 4.165 10.7102 2.65625 8.85438 2.65625H5.31271C3.45688 2.65625 1.94812 4.165 1.94812 6.02083C1.94812 6.8 2.22437 7.55791 2.72021 8.15999C2.90437 8.38666 2.87604 8.71957 2.64937 8.91082C2.42271 9.09499 2.08979 9.06667 1.89854 8.84001C1.23979 8.04667 0.87854 7.04792 0.87854 6.02083C0.87854 3.57708 2.86187 1.59375 5.30562 1.59375H8.84729C11.291 1.59375 13.2744 3.57708 13.2744 6.02083C13.2744 8.46458 11.2981 10.4479 8.85438 10.4479Z'
                fill='currentColor'
            />
            <path
                d='M11.6875 15.4064H8.14583C5.70208 15.4064 3.71875 13.4231 3.71875 10.9793C3.71875 8.53558 5.70208 6.55225 8.14583 6.55225H9.91667C10.2071 6.55225 10.4479 6.79308 10.4479 7.0835C10.4479 7.37391 10.2071 7.61475 9.91667 7.61475H8.14583C6.29 7.61475 4.78125 9.1235 4.78125 10.9793C4.78125 12.8352 6.29 14.3439 8.14583 14.3439H11.6875C13.5433 14.3439 15.0521 12.8352 15.0521 10.9793C15.0521 10.2002 14.7758 9.44225 14.28 8.84017C14.0958 8.6135 14.1242 8.28059 14.3508 8.08934C14.5775 7.89809 14.9104 7.93349 15.1017 8.16015C15.7604 8.95349 16.1217 9.95225 16.1217 10.9793C16.1146 13.4231 14.1312 15.4064 11.6875 15.4064Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default LinkIcon;

